var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEuropeanUnion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#112f95",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6cd46",
    d: "m15 4.17-.26.78h-.82l.67.48-.26.79.67-.49.67.49-.26-.79.67-.48h-.82zm.26 14.4-.26-.79-.26.79h-.82l.67.48-.26.78.67-.48.67.48-.26-.78.67-.48zm-7.07-6.03.67.49-.25-.79.66-.48h-.82l-.26-.79-.25.79H7.1l.67.48-.25.79zm3.4-7.46-.25.78h-.82l.66.49-.25.78.67-.48.66.48-.25-.78.67-.49h-.83zM9.12 7.57l-.26.78h-.82l.66.49-.25.78.67-.48.66.48-.25-.78.66-.49h-.82zm.25 7.6-.25-.8-.26.8h-.82l.66.48-.25.78.67-.48.66.48-.25-.78.66-.49zm2.5 2.48-.26-.78-.26.78h-.82l.66.49-.25.78.67-.48.66.48-.25-.78.67-.49zm11.03-5.9h-.83l-.25-.78-.26.79h-.82l.66.48-.25.79.67-.49.66.49-.25-.79zm-4.5-6.66-.25.78h-.82l.66.49-.25.78.66-.48.67.48-.25-.78.66-.49h-.82zm2.08 3.76-.25.78.66-.48.67.48-.25-.78.66-.49h-.82l-.25-.78-.26.78h-.82zm.67 6.32-.25-.78-.26.78h-.82l.66.49-.25.78.66-.48.67.48-.25-.78.66-.49zm-2.5 2.5-.25-.8-.25.8h-.82l.66.48-.25.78.66-.48.67.48-.25-.78.66-.49z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuropeanUnion);
export default __webpack_public_path__ + "static/media/european-union.d8d565426e9da6b9535390a16fea354b.svg";
export { ForwardRef as ReactComponent };